import { Injectable, inject } from '@angular/core';
import {BreakpointObserver, Breakpoints} from "@angular/cdk/layout";
import {Observable} from "rxjs";
import {BreakpointValue} from "../../models";
import {map} from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class BreakpointObserverService {
    private readonly breakPointObserver = inject(BreakpointObserver);


    public getCurrentBreakpoint(): Observable<BreakpointValue> {
        return this.breakPointObserver.observe([
            Breakpoints.XLarge,
            Breakpoints.Large,
            Breakpoints.Medium,
            Breakpoints.Small
        ])
            .pipe(
                map(result => {
                    if (result.breakpoints[Breakpoints.Large]) {
                        return BreakpointValue.LARGE;
                    } else if (result.breakpoints[Breakpoints.Medium]) {
                        return BreakpointValue.MEDIUM;
                    } else if (result.breakpoints[Breakpoints.Small]) {
                        return BreakpointValue.SMALL;
                    } else if (result.breakpoints[Breakpoints.XLarge]) {
                        return BreakpointValue.XLARGE;
                    }
                    else {
                        return null;
                    }
                })
            );
    }
}
